import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=452de63a&scoped=true&functional=true&"
var script = {}
import style0 from "./empty.vue?vue&type=style&index=0&id=452de63a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "452de63a",
  null
  
)

export default component.exports